import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { CurrentContext } from '../models';
import { InternationalDropdown } from './international-dropdown';
import { LandingPageReportDownload } from './landing-page-report-download';
import { ProvinceDropdown } from './provinces-dropdown';
import { RegionDropdown } from './region-dropdown';


export function ClergCompReportDropdown() {
	const context = useSelector<TcsmStates, CurrentContext>(state => state.clergyCompReportState.currentContext);

	switch (context) {
		case CurrentContext.LANDING:
			return <LandingPageReportDownload />;
		case CurrentContext.DOMESTIC:
			return <ProvinceDropdown />;
		case CurrentContext.INTERNATIONAL:
			return <InternationalDropdown />;
		case CurrentContext.REGION:
			return <ProvinceDropdown />;
		case CurrentContext.DIOCESE:
			return <RegionDropdown />;
		case CurrentContext.INTERNATIONDIO:
			return <InternationalDropdown />;
		default:
			return null;
	}
}